import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";

class GetBannerSessionAction extends BaseAction<void, boolean> {
  override async run(): Promise<void> {
    try {
      const isHidden = sessionStorage.getItem("hideBanner");
      const hideBanner = isHidden === "true";
      if (hideBanner) {
        updateRecoilState("getAppBanner", false);
      } else {
        updateRecoilState("getAppBanner", true);
      }
    } catch (error: any) {
      console.log("Error reading session storage:");
    }
  }
}

export const getBannerSessionAction = new GetBannerSessionAction();
